import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {TheRave} from "../../TheRave";
import {TheRaveSound} from "../../sound/TheRaveSound";

export class XWaysExpansion extends WinPresentationController {

    private _animations: TimelineLite[] = [];

    constructor() {
        super("XWaysExpansion", true);
    }

    protected hasWin(): boolean {
        return TheRave.model.parsedGameData.hasXWays;
    }

    protected async createWinAnimation(): Promise<void> {
        //TODO: Not use singlewin, check if xw is in betline win instead
        const hasSingleWin:boolean = TheRave.model.parsedGameData.singleWin>0;
        const potentialWin:boolean = TheRave.model.parsedGameData.potentialWin;

        this._animations = TheRave.XWaysController.expand(hasSingleWin || potentialWin);
        await Promise.resolve(new TimelineLite()
            .add(this._animations, 0.1)
            .add(()=>TheRaveSound.playSoundEffect((<any>TheRaveSound)[`XWAY_SYMBOL_EXPAND${hasSingleWin || potentialWin?"":"_FAST"}`]),0.1));
        await TheRave.ways.xWays();
    }

    public skip(): void {
        this._animations.forEach(animation => {
            animation.timeScale(2);
        })
    }
}